import c from 'classnames';

import { TypographyColors } from '../Typography/types';
import {
  DEFAULT_INPUT_TYPOGRAPHY_VARIANT,
  INPUT_ADORNMENT_SPACING_CONFIG,
  INPUT_APPEARANCE_CLASSES,
  INPUT_DISABLED_CLASSES,
  INPUT_SHAPE_CLASSES,
  INPUT_SIZE_CLASSES,
} from './consts';
import { inputStyles } from './styles';
import { InputAdornmentEnum, InputAppearance, InputProps, InputShape, InputSize } from './types';

const getInputAdornmentEnum = (params: Pick<InputProps, 'endAdornment' | 'startAdornment'>) => {
  const { endAdornment, startAdornment } = params;

  if (endAdornment && startAdornment) {
    return InputAdornmentEnum.Both;
  } else if (endAdornment) {
    return InputAdornmentEnum.End;
  } else if (startAdornment) {
    return InputAdornmentEnum.Start;
  } else {
    return InputAdornmentEnum.None;
  }
};
interface GetInputClassesParams extends Pick<InputProps, 'endAdornment' | 'startAdornment'> {
  appearance: InputAppearance;
  color: TypographyColors;
  shape: InputShape;
  size: InputSize;
  variant?: InputProps['variant'];
}

export const getInputTypographyVariant = (
  params: Pick<GetInputClassesParams, 'size' | 'variant'>,
) => {
  const { size, variant } = params;
  return variant || DEFAULT_INPUT_TYPOGRAPHY_VARIANT[size];
};

export const getInputClasses = (params: GetInputClassesParams) => {
  const { appearance, color, endAdornment, shape, size, startAdornment, variant } = params;

  const appearanceClassname = INPUT_APPEARANCE_CLASSES[appearance];
  const shapeClassname = INPUT_SHAPE_CLASSES[shape];
  const sizeClassname = INPUT_SIZE_CLASSES[size];
  const spacingClasses =
    INPUT_ADORNMENT_SPACING_CONFIG[size][shape][
      getInputAdornmentEnum({ endAdornment, startAdornment })
    ];

  return {
    disabled: c(INPUT_DISABLED_CLASSES[appearance], 'pointer-events-none'),
    input: c(
      'p-0 h-auto self-stretch placeholder-text-placeholder',
      color,
      variant,
      spacingClasses.input,
    ),
    inputAdornedEnd: 'me-4',
    inputAdornedStart: 'ms-8',
    inputMultiline: spacingClasses.inputMultiline,
    multiline: c('p-0', spacingClasses.multiline),
    notchedOutline: 'border-none',
    root: c(
      'overflow-hidden',
      inputStyles,
      sizeClassname,
      shapeClassname,
      appearanceClassname,
      spacingClasses.root,
    ),
  };
};
